<template>
  <div class="banners"
       style="background: #f6f6f6;padding-bottom: 300px;">
    <div class="wx_pay_box">
      <div>
        <img src="../../assets/images/headerLogo.png" style="width: 200px;height: 42px;"
             alt="安徽继续教育网">
      </div>
      <div class="head">
        <div>订单编号：{{ orderInfo.order.orderNo }}</div>
        <div>应付金额：<span style="color: #EF1300;font-size: 25px;">￥{{  orderInfo.order.ordMoneysum }}</span> 元</div>
      </div>

      <div class="wx_pay_content">
        <div>
          <img src="../../assets/images/wxewm_07.png"
               alt="安徽继续教育网">
        </div>

        <div class="ss">
          <div>
            <div>
                 <div id="qrcode" style="margin-top: 20px"></div>

            </div>
            <div style="margin-top: 15px;">
              <img src="../../assets/images/wxewm_16.png"
                   alt="安徽继续教育网">
            </div>
          </div>
          <div style="margin-left: 80px;">
            <img src="../../assets/images/wxewm_13.png"
                 alt="安徽继续教育网">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import '@/utils/qrcode.js';
import { toTradeQuery } from '@/api/pay.js';
import { toTradeQueryWX, toTradeQueryWX2, getExpressDetail, getOrderPayInfo } from '@/api/pay.js';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      wxInfo: {},
      timer: null,
         orderInfo: {
        order: {
          id: this.$route.query.orderId,
          ordMoneysum:this.$route.query.ordMoneysum,
          orderNo:this.$route.query.orderNo,
          
        }
      },
      checkInterval: null // 定时器引用
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
    mounted() {
    this.text = this.$route.query.data;
    const orderId = this.$route.query.orderId;
    if (!orderId) {
      this.$message.error('缺少订单ID');
      return;
    }

    // 渲染二维码
    if (this.text) {
      this.$nextTick(() => {
        const container = document.getElementById('qrcode');
        if (container) {
          container.innerHTML = '';
          new QRCode(container, {
            text: this.text,
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          });
        }
      });
    }

    // 启动轮询：每 2 秒检查一次支付状态
    this.startPolling();
  },
   beforeDestroy() {
    // 组件销毁前清除定时器
    this.stopPolling();
  },
  methods: {
    startPolling() {
      this.checkInterval = setInterval(() => {
        this.toTradeQueryZFB();
      }, 2000); // 每2000毫秒（2秒）调用一次
    },
    stopPolling() {
      if (this.checkInterval) {
        clearInterval(this.checkInterval);
        this.checkInterval = null;
      }
    },
    toTradeQueryZFB() {
      const orderId = this.orderInfo.order.id;
      if (!orderId) return;

      toTradeQuery({ orderId ,ordPayType:this.$route.query.ordPayType})
        .then(res => {
          const result = res?.data?.data?.result;
          console.log('对账结果:', result);

          if (result !== '2') {
            this.stopPolling();

            this.$message({
              message: '支付成功！',
              type: 'success'
            });

            this.$router.push({
              path: '/paySuccess',
              query: {
                orderId: this.orderInfo.order.id
              }
            });
          }
        })
        .catch(err => {
          console.error('对账请求失败:', err);
        });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
        this.wxInfo = {
          codeUrl: this.$route.query.codeUrl,
          orderNo: res.data.data.expressNo,
          orderId: res.data.data.id,
          money: res.data.data.expressPrice,
          yd: 1
        };
       
    },
  // // 生命周期 - 挂载完成（可以访问DOM元素）
  // mounted() {
  //   if (this.$route.query.yd && this.$route.query.yd == '1') {
  //     this.timer = setInterval(() => {
  //       this.toTradeQueryWX2();
  //     }, 5000);
  //   } else {
  //     this.timer = setInterval(() => {
  //       this.toTradeQueryWX();
  //     }, 5000);
  //   }
  // },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  destroyed() {
    clearInterval(this.timer);
  }
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.banners {
  display: flex;
  justify-content: center;
  padding-top: 25px;
  font-size: 19px;
  font-family: Regular;
  background: #f6f6f6;
  .wx_pay_box {
    width: 1024px;
    .head {
      margin-top: 45px;
      display: flex;
      justify-content: space-between;
    }
    .wx_pay_content {
      margin-top: 25px;
      background: #fff;
      width: 1024px;
      height: 596px;
      padding: 20px 0 0 50px;
      .ss {
        display: flex;
        padding: 40px 545px 123px 155px;
      }
    }
  }
}
</style>